export const $win = $(window);
export const $document = $(document);
export const $body = $('body');
